



































import { Owner, OwnerFilter, everyOwner } from "@/api/owner/types";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import 'vue-select/dist/vue-select.css';
import * as ownerService from '@/services/owner'
import { debounce } from "lodash";


@Component({
  name: "OwnerSelect",
})
export default class OwnerSelect extends Vue {
  @Prop({ type: Boolean, default: false })
  private isVisible!: boolean;

  @Prop({ type: Object, default: null})
  private value!: Owner | null;

  @Prop({ type: Boolean, default: false })
  private excludeAllOwners!: boolean;

  private observer: IntersectionObserver = new IntersectionObserver(this.infiniteScroll);
  private search = '';
  private owners: Owner[] = [];
  private currentPage = 0;
  private pageSize = 25;
  private maxPage = 0;

  private owner: Owner | null = null;

  private handleInput(event: any){
    this.$emit("input", event);
  }

  private async mounted() {
    await this.loadNextPage();
  }

  private async loadNextPage() {
    const response = await ownerService.fetchAllByFilterWithoutStore(
      new OwnerFilter(this.search, undefined, undefined, undefined, undefined, false),
      { page: this.currentPage, size: this.pageSize}
    );
    
    this.maxPage = response.totalPages;
    if (this.currentPage === 0) {this.owners = []};
    this.owners = this.owners.concat(response.data);
    this.currentPage += 1;
  }

  private debouncedLoadNextPage = debounce(this.loadNextPage.bind(this), 800)

  private get paginated () {
    const baseList = this.excludeAllOwners ? [] : [everyOwner];
    return baseList.concat(this.owners);
  }

  private get hasNextPage () {
    return this.currentPage < this.maxPage;
  }

  @Watch('hasNextPage')
  private async changedNextPage(hasNextPage: boolean) {
    if (hasNextPage) {
      await this.$nextTick();
      if (!!this.$refs.loadOptions) {
        this.observer.observe(this.$refs.loadOptions as Element);
      }
    } else {
      this.observer.disconnect();
    }
  }

  private async onOpenSelect () {
    if (this.hasNextPage) {
      await this.$nextTick();
      this.observer.observe(this.$refs.loadOptions as Element);
    }
  }
  private onCloseSelect () {
    this.observer.disconnect();
  }
  
  private async infiniteScroll ([{isIntersecting, target}]: IntersectionObserverEntry[]) {
    if (isIntersecting) {
      const ul = (target as any).offsetParent;
      const scrollTop = (target as any).offsetParent.scrollTop;
      if (this.hasNextPage) {
        await this.loadNextPage();
      }
      await this.$nextTick();
      ul.scrollTop = scrollTop;
    }
  }

  private async fetchSearchOptions(search: string, loading: (arg0: boolean) => void) {
    this.currentPage = 0;
    this.maxPage = 0;
    this.search = search;
    loading(true);
    await this.debouncedLoadNextPage();
    loading(false);
  }
}
